export function getEspLabel({ totalMsrp, suggestedPrice, nationalBasePriceTmv }) {
  if (nationalBasePriceTmv) {
    return 'National Market Price';
  }

  if (!suggestedPrice) {
    return totalMsrp ? 'Total MSRP' : 'Base MSRP';
  }

  return suggestedPrice > totalMsrp ? 'What others are paying' : 'Edmunds suggests you pay';
}

export function getSuggestedDisplayPrice({ nationalBasePriceTmv, suggestedPrice, totalMsrp, baseMsrp }) {
  return nationalBasePriceTmv || suggestedPrice || totalMsrp || baseMsrp;
}

export function getMsrpDisplayPrice({ totalMsrp, baseMsrp }) {
  return totalMsrp || baseMsrp;
}

export function getEspLabelFromTrim(trimSummary) {
  const totalMsrp = trimSummary?.pricing?.totalMsrp;
  const suggestedPrice = trimSummary?.pricing?.suggestedPrice;
  const nationalBasePriceTmv = trimSummary?.pricing?.nationalBasePrice?.tmv;

  return getEspLabel({ suggestedPrice, totalMsrp, nationalBasePriceTmv });
}

export function getSuggestedDisplayPriceFromTrim(trimSummary) {
  const totalMsrp = trimSummary?.pricing?.totalMsrp;
  const baseMsrp = trimSummary?.pricing?.baseMsrp;
  const suggestedPrice = trimSummary?.pricing?.suggestedPrice;
  const nationalBasePriceTmv = trimSummary?.pricing?.nationalBasePrice?.tmv;

  return getSuggestedDisplayPrice({ nationalBasePriceTmv, suggestedPrice, totalMsrp, baseMsrp });
}

export function getMsrpDisplayPriceFromTrim(trimSummary) {
  const totalMsrp = trimSummary?.pricing?.totalMsrp;
  const baseMsrp = trimSummary?.pricing?.baseMsrp;

  return getMsrpDisplayPrice({ totalMsrp, baseMsrp });
}
